import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { FormsService } from '../forms.service';
import { ReferralForm } from '../../shared/models/referral-form.model';
import { ReferralFormType } from '../../shared/models/referral-form-type.model';
import { MatDialog } from "@angular/material/dialog";
import { ConfirmDialogComponent } from "../../shared/confirm-dialog/confirm-dialog.component";
import { YesNo } from "../../shared/enums/yes-no.enum";
import { Subject } from 'rxjs';
import { takeUntil, tap, catchError } from 'rxjs/operators';
import Yes = YesNo.Yes;
import { FeedbackService } from "../../shared/services/feedback.service";

@Component({
  selector: 'app-forms-list',
  templateUrl: './forms-list.component.html',
  styleUrls: ['./forms-list.component.scss'],
  providers: [FormsService, FeedbackService]
})
export class FormsListComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  formsList: ReferralForm[];
  formTypesList: ReferralFormType[];
  isLoading: boolean = false;
  public loadingMessage = "Loading...";

  constructor(
    private readonly route: Router,
    private readonly formsService: FormsService,
    private feedbackService: FeedbackService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.fetchAllReferralFormTypes();
    this.fetchAllReferralForms();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  edit(referralFormId: number): void {
    this.route.navigate(['forms/edit/' + referralFormId]);
  }

  preview(referralFormId: number): void {
    this.route.navigate(['forms/preview/' + referralFormId]);
  }

  delete(referralFormId: number, name: string): void {
    
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "250px",
      data: {
        title: "",
        message: "Are you sure you want to delete this form? This cannot be undone.",
      },
    });

    dialogRef.afterClosed()
      .pipe(
        takeUntil(this.destroy$),
        tap((result: YesNo) => {
          if (result === Yes) {
            this.formsService.deleteReferralForm(referralFormId)
              .pipe(
                takeUntil(this.destroy$),
                tap(() => {
                  this.feedbackService.success(`${name} deleted.`);
                  this.fetchAllReferralForms();
                }),
                catchError(() => {
                  this.feedbackService.error('Could not delete form ${name}.');
                  return [];
                })
              )
              .subscribe();
          }
        })
      )
      .subscribe();
  }

  create() {
    this.route.navigate(['forms/create']);
  }

  getReferralFormActive(form: ReferralForm): boolean {
    return form.active;
  }

  getReferralFormTypeName(referralFormTypeId: number): string {
    var result = this.formTypesList.find(obj => {
      return obj.referralFormTypeId === referralFormTypeId;
    })?.description;

    return result ? result : "not found";
    
  }

  private fetchAllReferralForms() {
    this.isLoading = true;
    this.formsService.getAllReferralForms().pipe(
      takeUntil(this.destroy$)
    ).subscribe({
      next: (response) => {
        if (!response) {
          this.feedbackService.show("Issue with loading forms");
        }
        this.formsList = response;
      },
      error: (error) => {
        this.feedbackService.error(error);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  private fetchAllReferralFormTypes() {
    this.isLoading = true;
    this.formsService.getAllReferralFormTypes().pipe(
      takeUntil(this.destroy$)
    ).subscribe({
      next: (response) => {
        if (!response) {
          this.feedbackService.show("Issue with loading form types");
        }
        this.formTypesList = response;
      },
      error: (error) => {
        this.feedbackService.error(error);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

}
